import { models } from "powerbi-client";
import { applyInFilter } from "./dashboard-filters";

export const hidePages = async (embedConfig, reportingInstance) => {
  if (reportingInstance.current) {
    const pages = await reportingInstance.current.getPages();
    const hiddenPages = new Set(embedConfig["hidden_pages"].map((x) => x["page_name"]));
    for (const p of pages) {
      if (hiddenPages.has(p["name"])) {
        await p.delete();
      }
    }
  }
  return new Promise((resolve) => resolve(true));
};

export const eventHandlerReports = (embedConfig, reportingInstance, setLoading) => {
  return new Map([
    [
      "loaded",
      async () => {
        const t = await hidePages(embedConfig, reportingInstance);
        const f = await applyInFilter(embedConfig, reportingInstance);
        setLoading(false);
      },
    ],
    [
      "rendered",
      async () => {
        // const filters = await reportingInstance.current.getFilters();
      },
    ],
    [
      "error",
      function () {
        setLoading(false);
      },
    ],
  ]);
};

export const embedConfiguration = (embedConfig) => {
  return {
    ...embedConfig,
    type: "report",
    id: embedConfig?.["reportId"] ?? "",
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      //   background: models.BackgroundType.Transparent,
    },
  };
};
